import React from 'react';
import { Link } from 'react-router-dom';
import styles from './About.module.css';

const featureCards = [
  {
    eyebrow: 'Spotting',
    title: 'Make spots worth revisiting',
    description:
      'Post memorable car sightings in the wild for the community to discover and appreciate.',
    highlights: [
      'Post multiple images per spot', 
      'Quick posting with AI assisted car identification so you don\'t have to manually enter details', 
      'Postings added to the feed for everyone to appreciate',
      'Add location, caption and car details to add more rich details about the car',
      'Other community members can comment on your spot to show appreciation and add context'
    ],
  },
  {
    eyebrow: 'Garage',
    title: 'A place to share your car journey',
    description:
      'Your garage is where you showcase your enthusiasm for your car(s). Other community members can appreciate your builds and passion you have for your car.',
    highlights: [
      'Provide extra details about your car', 
      'Car build history with pictures and captions', 
      'Can embed youtube videos of your builds',
      'Record your track performance history'
    ],
  },
  {
    eyebrow: 'Leaderboards',
    title: 'Reward the people who keep the site alive',
    description:
      'Leaderboards spotlight the members whose spots earn attention, whose consistency keeps the feed moving, and whose taste gets noticed by the community.',
    highlights: ['See all-time contributors', 'Follow weekly momentum', 'Discover the community favorites'],
  },
];

export function About() {
  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <div className={styles.heroCopy}>
          <p className={styles.kicker}>About RideSpot</p>
          <h1>Built for people who who have passion for cars and want to share it with others.</h1>
          <p className={styles.lead}>
            RideSpot is a community for sharing memorable car sightings, your personal car build journey 
            and track performance. Whether you’re out spotting or building your own ride, RideSpot is a place to 
            share the moments that make car culture special.
          </p>
          <div className={styles.heroActions}>
            <Link to="/spot" className={styles.primaryAction}>
              Add a spot
            </Link>
            <Link to="/garage" className={styles.secondaryAction}>
              View my garage
            </Link>
          </div>
        </div>
        <div className={styles.heroPanel}>
          <p className={styles.panelLabel}>What stands out</p>
          <ul className={styles.panelList}>
            <li>Post multiple images per spot with AI assited car identification.</li>
            <li>Personal garage that can showcase your ride, build history and track peformance</li>
            <li>Leaderboards that highlight top contributors and community favorites</li>
          </ul>
        </div>
      </section>

      <section className={styles.featuresSection}>
        <div className={styles.sectionHeading}>
          <p className={styles.sectionLabel}>Main features</p>
          <h2>The core of the site revolves around three things</h2>
        </div>
        <div className={styles.featureGrid}>
          {featureCards.map((feature) => (
            <article key={feature.title} className={styles.featureCard}>
              <p className={styles.featureEyebrow}>{feature.eyebrow}</p>
              <h3>{feature.title}</h3>
              <p className={styles.featureDescription}>{feature.description}</p>
              <ul className={styles.featureHighlights}>
                {feature.highlights.map((highlight) => (
                  <li key={highlight}>{highlight}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      {/* <section className={styles.stepsSection}>
        <div className={styles.sectionHeading}>
          <p className={styles.sectionLabel}>How it fits together</p>
          <h2>From a single sighting to a recognizable presence</h2>
        </div>
        <div className={styles.stepsGrid}>
          {steps.map((step, index) => (
            <article key={step.title} className={styles.stepCard}>
              <span className={styles.stepNumber}>0{index + 1}</span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </article>
          ))}
        </div>
      </section> */}
    </div>
  );
}
